import React from 'react';

type AccessibleHeaderElementProps = React.HTMLAttributes<HTMLHeadingElement> & { tag: any };

export const AccessibleHeaderElement = ({
    children,
    className,
    tag,
    ...props
}: AccessibleHeaderElementProps) => {
    const Element = tag;

    return (
        <Element className={className} {...props}>
            {children}
        </Element>
    );
};
